import { useShallow } from 'zustand/react/shallow';

import { useBoundStore } from '@/store/store';

export function useNavigate() {
  const { pushRoute, history, popRoute, route } = useBoundStore(
    useShallow(state => ({
      pushRoute: state.pushRoute,
      history: state.history,
      popRoute: state.popRoute,
      route: state.route,
    })),
  );

  return { navigate: pushRoute, history, popRoute, route };
}
